// export const Api = "http://api.brandscity.ir/api/v1/";

// export const Api = "https://parsian.asefmirzaei.ir/api/v1/";

export const Api = "https://parsianos.ir/amlak/api/v1/";